module.exports = __webpack_public_path__ + "img/level_four_lock.41f59b05.png";